// extracted by mini-css-extract-plugin
export default {"container":"QTZUrH","text":"vLNj0k"};